import React from 'react'
import { Col, Row } from 'react-bootstrap'
import ProductData from './ProductData'
import ProductGallery from './ProductGallery'

const ProductDetailsComp = () => {
  return (
    <Row className='py-5'>
        <Col lg="4">
            <ProductGallery/>
        </Col>

        <Col lg="8" className='d-flex align-items-center'>
            <ProductData/>
        </Col>
    </Row>
  )
}

export default ProductDetailsComp
